<template>
  <b-container>
    <h1>{{ $t("tracking.disapprovedReason.edit") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>

    <b-row>
      <b-col sm="12" md="6" lg="6">
        <disapproved-reason-crud-data
          :model="model"
          :modelstate="modelstate"
          :readonly="false"
          class="mb-4"
        >
        </disapproved-reason-crud-data>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button type="submit" :disabled="submitted" @click="save">
          {{ $t("geral.save") }}
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "DisapprovedReasonEdit",
  directives: {},
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    DisapprovedReasonCrudData: () =>
      import(
        "@/components_rms/trackingShippingCompany/disapprovedReason/DisapprovedReasonCrudData.vue"
      ),
  },
  props: {
    id: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Motivo reprovação editar com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        sequenceNumber: 0,
        displayName: "",
        id: 0,
        companyId: 0,
      },
    };
  },
  created() {
    this.loadData();
  },
  mounted() {},
  computed: {
    canEdit() {
      if (!this.model) {
        return false;
      }
      return true;
    },
    canSubmit() {
      if (this.submitted) {
        return true;
      }
      if (!this.canEdit) {
        return true;
      }
      return false;
    },
    getUrlBackToList() {
      return `/trackingShippingCompany/disapprovedReason/list`;
    },
    getDisapprovedReason() {
      return `/v1/disapprovedReason/get/${this.id}`;
    },
  },
  methods: {
    async loadData() {
      console.log("url");
      console.log(this.getDisapprovedReason);
      this.$api
        .get(this.getDisapprovedReason)
        .then((response) => {
          let model = response.data;
          this.model = model;
          console.log(model);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log(response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(response.data);
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    save() {
      this.submitted = true;

      this.$api
        .post("/v1/disapprovedReason/edit/" + this.model.id, this.model)
        .then((response) => {
          console.log("response.data");
          console.log(response.data);
          this.model = response.data;
          this.$forceUpdate();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
        })

        .catch((error) => {
          console.log("error");
          console.log(error);
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = error.message;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              this.alert.error = error.response.data;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
  watch: {
  },
};
</script>